import { useCollaborativeDocumentUpdatedSubscription } from '@spotify/confidence-graphql';

export const useCollaborativeDocumentUpdates = () => {
  // The backend subscription is not scoped by document name; Apollo writes only
  // the normalized collaborative document that changed, so unrelated updates
  // do not replace active query results.
  useCollaborativeDocumentUpdatedSubscription({});
};
